import React from 'react'

import { ChargePoint } from '../../common/redux/api/web-api'
import findChargingConnector from '../../lib/findChargingConnector'
import { AuraConnectorInfo } from '../../lib/aura-connector-info'
import isAura from '../../lib/isAura'

import ConnectorInfo from './ConnectorInfo'

type SettingsInfoProps = {
    chargePoint: ChargePoint
}

const SettingsInfo = ({ chargePoint }: SettingsInfoProps): React.ReactElement => {
    return (
        <span>
            {chargePoint?.ocppServerMode === 'External' && <span>---</span>}
            {chargePoint?.ocppServerMode !== 'External' && !isAura(chargePoint) && (
                <ConnectorInfo connector={findChargingConnector(chargePoint?.connectors)} chargePoint={chargePoint} />
            )}
            {chargePoint?.ocppServerMode !== 'External' &&
                isAura(chargePoint) &&
                chargePoint?.connectors.map((connector) => (
                    <AuraConnectorInfo key={connector?.connectorId} chargePoint={chargePoint} connector={connector} />
                ))}
        </span>
    )
}

export default SettingsInfo
